import React from 'react';
import { connect } from "react-redux";
import {hashHistory} from "react-router";
import {FormattedMessage} from "react-intl";

import {
  changeActivePartRelatedItemIndex, setCameFromPage, setQtActiveCategory,
  toggleBathroomVisualizerOpen, toggleSelectionWindow
} from "../../actions/actionFunctions";
import DesktopHeader from "../desktopHeader";
import {showWizardInsteadOfQT} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import goToMaterialPage from "../common/goToMaterialPage";
import {removeLoadingElements} from "../../loadingLogic";

class QuoteDesignPage extends React.Component {

  componentDidMount() {
    if (this.props.bvOpened) {
      this.props.toggleBathroomVisualizerOpen(false);
    }
    removeLoadingElements("QuoteDesign");
  }

  goToVisualizer = () => {
    this.props.toggleBathroomVisualizerOpen(true);
    hashHistory.push('visualizer');
  };

  goToQuotingTool = () => {
    const {wizardList, wizardIsActive} = this.props;
    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      goToMaterialPage();
      return
    }
    hashHistory.push('/materials');
  };

  render() {
    const buttonClass = this.props.windowWidth > 991 ? "ui-button3 ui-button3--blue" : "ui-button2 ui-button2--blue";
    return (
      <div className="qt-des">
        {this.props.windowWidth > 991 ? <DesktopHeader uploadsAndNotes={false} hideTopButtons={true}/> : null}
        <div className="qt-des-content">
          <div className="qt-des-sections">
            <section className="qt-des-sections__section qt-des-sections__section--shop">
              <h2 className="qt-des-title">
                <span className="qt-des-title__main"><FormattedMessage id="quoteDesignPage.shopSection.title1"/></span>
                <span className="qt-des-title__text"><FormattedMessage id="quoteDesignPage.shopSection.title2"/></span>
              </h2>
              <div className="qt-des-button">
                <button className={buttonClass} onClick={this.goToQuotingTool}>
                  <FormattedMessage id="quoteDesignPage.shopSection.button"/>
                </button>
              </div>
            </section>
            <section className="qt-des-sections__section qt-des-sections__section--visualize">
              <h2 className="qt-des-title text-right">
                <span className="qt-des-title__main">
                  <FormattedMessage id="quoteDesignPage.designSection.title1"/>
                </span>
                <span className="qt-des-title__text">
                  <FormattedMessage id="quoteDesignPage.designSection.title2"/>
                </span>
              </h2>
              <div className="qt-des-button">
                <button className={buttonClass} onClick={this.goToVisualizer}>
                  <FormattedMessage id="quoteDesignPage.designSection.button"/>
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {wizardList, wizardIsActive} = store.wizardState;
  return {
    wizardList,
    wizardIsActive,
    windowWidth: store.serverState.windowWidth,
    bvOpened: store.bathroomVisualizerState.bvOpened,
  };
};

export default connect(mapStateToProps, {
  toggleBathroomVisualizerOpen,
  setQtActiveCategory,
  changeActivePartRelatedItemIndex,
  toggleSelectionWindow,
  setCameFromPage
})(QuoteDesignPage);
